import providerService from '../services/providerService';

export const PROVIDERS_COLLECTED = '@driverStatus/drivers-collected';

export function getProviders() {
  return async (dispatch) => {
    try {
      const providers = await providerService.getProviders();

      dispatch({
        type: PROVIDERS_COLLECTED,
        payload: {
          providers
        }
      });
    } catch (error) {
      throw error;
    }
  };
}
